import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import AppRoutes from './AppRoutes';
import { Layout } from './components/layout/Layout';
import { useContentStore } from './providers/stores/content-store';
import { HomeApi } from './api';

import './scss/custom.scss';
import 'react-responsive-modal/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './hooks/useAuth';
import useDidMount from 'beautiful-react-hooks/useDidMount';

const App = () => {

	const setContent = useContentStore((state) => state.setContent);

	useDidMount(() => {
		initApp();
	});

	const initApp = async () => {
		let initResponse = await HomeApi.initialize();

		setContent(initResponse.content);
	};

	return (
		<AuthProvider>
			<Layout>
				<Routes>
					{AppRoutes.map((route, index) => {
						const { element, ...rest } = route;
						return <Route key={index} {...rest} element={element} />;
					})}
				</Routes>
				<ToastContainer
					className="gat-toast-container"
					toastClassName="gat-toast"
					pauseOnHover
					theme="colored"
				/>
			</Layout>
		</AuthProvider>
	);
}
App.displayName = App.name;

export default App;